import './_collection-title-delivery-selection.scss';

export default () => {};
